if (!customElements.get("best-seller-section")) {
    class BestSellerSection extends HTMLElement {
        constructor() {
            super();
            this.section = this.querySelector('.best-seller-section__products');
            this.swiperContainer = this.section.querySelector('.swiper');
            this.swiper = null;
            this.productItem = this.section.querySelectorAll('.best-seller-section__product_item');
        }

        connectedCallback() {
            this.initContainerSwiper();
            this.initImageSwipers();
            this.attachVariantListeners();
        }

        initContainerSwiper() {
            const prevButton = this.section.querySelector('.swiper-button-prev');
            const nextButton = this.section.querySelector('.swiper-button-next');
            this.swiper = new Swiper(this.swiperContainer, {
                slidesPerView: 3,
                spaceBetween: 30,
                speed:300,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                navigation: {
                    prevEl: prevButton || null,
                    nextEl: nextButton || null,
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        autoplay: false
                    },
                    768: {
                        slidesPerView: 1.3,
                        autoplay: false
                    },
                    1000: {
                        slidesPerView: 2,
                        autoplay: false
                    },
                    1300: {
                        slidesPerView: 3,
                        autoplay: false
                    }
                }
            });
        }

        initImageSwipers() {
            this.productItem.forEach(productItem => {
                const thumbSwiperContainer = productItem.querySelector('.card__media_thumbnail .swiper');
                const mainImageSwiperContainer = productItem.querySelector('.best_seller_card_main_image_container .swiper');

                // 初始化 Thumb Swiper
                if (thumbSwiperContainer) {
                    productItem.thumbSwiper = new Swiper(thumbSwiperContainer, {
                        direction: 'vertical',
                        slidesPerView: 5,
                        spaceBetween: 12,
                        watchSlidesVisibility: true,
                        breakpoints: {
                            320: {
                                spaceBetween: 10
                            },
                            768: {
                                spaceBetween: 5
                            },
                            1280: {
                                spaceBetween: 12,
                            }
                        }
                    });
                }

                // 初始化 Main Image Swiper
                if (mainImageSwiperContainer) {
                    productItem.mainImageSwiper = new Swiper(mainImageSwiperContainer, {
                        slidesPerView: 1,
                        allowTouchMove: false,
                        spaceBetween: 0,
                        effect: 'fade',
                        fadeEffect: { crossFade: true },
                        thumbs: { swiper: productItem.thumbSwiper },
                    });
                }
            });
        }

        attachVariantListeners() {
            this.productItem.forEach(productItem => {
                const variantSelectors = productItem.querySelectorAll('.card_product-card__swatch--list .color-swatch-item');

                variantSelectors.forEach(variant => {
                    variant.addEventListener('click', () => {
                        const variantId = variant.getAttribute('data-id');

                        // 获取变体 ID 可能是多个值，用逗号分隔
                        const variantIds = variantId.split(',').map(id => id.trim()); // 分割并去除空格

                        // 获取对应的 Swiper 实例
                        const thumbSwiper = productItem.thumbSwiper;
                        const mainImageSwiper = productItem.mainImageSwiper;

                        // 切换缩略图和主图的公共逻辑
                        const switchSlides = (swiper, slidesSelector, variantIds) => {
                            const slides = productItem.querySelectorAll(slidesSelector);
                            slides.forEach((slide, index) => {
                                const slideVariantIds = slide.getAttribute('data-variant-id').split(',').map(id => id.trim());

                                // 判断当前的 slide 的 data-variant-id 是否包含 variantIds 中的任何一个变体 ID
                                if (variantIds.some(id => slideVariantIds.includes(id))) {
                                    swiper.slideTo(index); // 切换幻灯片
                                }
                            });
                        };

                        // 如果存在 thumbSwiper 实例，则切换缩略图
                        if (thumbSwiper) {
                            switchSlides(thumbSwiper, '.card__media_thumbnail .swiper-slide', variantIds);
                        }

                        // 如果存在 mainImageSwiper 实例，则同步主图
                        if (mainImageSwiper) {
                            switchSlides(mainImageSwiper, '.best_seller_card_main_image_container .swiper-slide', variantIds);
                        }
                    });
                });
            });
        }
    }

    customElements.define("best-seller-section", BestSellerSection);
}